/* global location */
import React from 'react';

import {
  restaurantById,
  currentSlotSelector,
  maxPeopleSelector,
  pickerSeatsSelector,
  slotsAvailableSelector,
  pickerTimeSelector,
  formDataSelector,
} from '@arreeba/ristoranti-frontend-lib';

import TimeHelpers from '@arreeba/ristoranti-frontend-lib/lib/helpers/time';

import { COMMON_LOCALIZED } from '../../lib/localized';
import { connect } from '../../util';
import Spinner from '../../components/spinner';
import FormWrapper from '../../components/form-wrapper';
import ButtonsContainer from '../../components/buttonsContainer';
import BackButton from '../../components/back-button';

const privacyLabel = (
  <span>
    Accetto le <a href="https://ristoranti.it/privacy" target="_blank">condizioni d'uso e il trattamento dati</a>
  </span>);

class BookingForm extends React.Component {
  constructor(props) {
    super(props);
    const config = [
      {
        label: 'Nome',
        name: 'name',
        format: 'string',
        placeholder: 'Nome',
        initialValue: '',
        isRequired: true,
      },
      {
        label: 'Cognome',
        name: 'lastName',
        format: 'string',
        placeholder: 'Cognome',
        initialValue: '',
        isRequired: true,
      },
      {
        label: 'E-mail',
        name: 'email',
        format: 'email',
        placeholder: 'E-mail',
        initialValue: '',
        isRequired: true,
      },
      {
        label: 'Numero di Telefono',
        name: 'phoneNumber',
        format: 'phoneNumber',
        placeholder: 'Telefono',
        initialValue: '',
        isRequired: true,
      },
      {
        label: 'Note',
        name: 'extraInfo',
        format: 'text',
        placeholder: 'Richieste aggiuntive',
        initialValue: '',
        isRequired: false,
      },
      {
        rightLabel: privacyLabel,
        name: 'privacy',
        type: 'checkbox',
        initialValue: '',
        format: 'boolean',
      },
    ];
    // prefill data from current user
    if (props.user.currentUser) {
      this.formConfig = config.reduce((acc, field) => {
        return [
          ...acc,
          {
            ...field,
            initialValue: props.user.currentUser[field.name] || '',
          },
        ];
      }, []);
    } else {
      this.formConfig = config;
    }
    this.save = this.save.bind(this);
  }

  save(formValue) {
    const { app, booking, actions } = this.props;

    const targetRestaurant = this.props.routeParams.restaurantId;
    const data = {
      app: app.id,
      availabilitySlot: booking.time,
      date: booking.date.date,
      name: formValue.name,
      lastName: formValue.lastName,
      phoneNumber: formValue.phoneNumber,
      extraInfo: formValue.extraInfo,
      email: formValue.email,
      people: booking.seats,
      restaurant: targetRestaurant,
      type: (booking.verifiedBookingRush) ? 'BOOKING_RUSH' : 'STANDARD',
      source: location.hostname,
      sourceType: 'WEB',
    };

    if (booking.hasBookingRushes) {
      data.bookingRush = app.bookingRush.id;
    }

    const fragment = 'id status date people availabilitySlot { open }';
    this.props.services.booking.createRequest(data, fragment, actions.booking);
  }

  render() {
    const { booking, app } = this.props;
    const targetRestaurant = this.props.routeParams.restaurantId;
    const restaurant = restaurantById(app.merchant.restaurants, targetRestaurant);

    if (booking.isFetching || booking.createdRequest.id) {
      return (
        <main>
          <div className="paymentContainer container--loading">
            <Spinner size="large" text="Prenotazione in corso..." />
          </div>
        </main>
      );
    }

    const locale = 'it';
    const day = TimeHelpers.weekDayLocale(booking.date.date, locale);
    const date = TimeHelpers.toLocalDate(booking.date.date, locale);
    return (
      <main>
        <p className="booking-info">
          Prenotazione per <strong>{day} {date}</strong> alle {booking.time}<br />
          <strong>{restaurant.name}</strong> – {restaurant.address}<br />
          {booking.seats} persone
        </p>

        <p>Inserisci i tuoi dati per completare la prenotazione</p>
        <FormWrapper
          config={this.formConfig}
          onValidSave={this.save}
          submitButtonLabel="PRENOTA"
        />
        <ButtonsContainer>
          <BackButton />
        </ButtonsContainer>
      </main>
    );
  }
}


const connectOptions = {
  mapStateToProps: (state, props) => ({
    ...state,
    currentSlot: currentSlotSelector(state, props),
    maxPeople: maxPeopleSelector(state, props),
    pickerSeats: pickerSeatsSelector(state, props),
    pickerTime: pickerTimeSelector(COMMON_LOCALIZED)(state, props),
    slotsAvailable: slotsAvailableSelector(state),
    formData: formDataSelector(state),
  }),
};


export default connect(BookingForm, connectOptions);



// WEBPACK FOOTER //
// ./src/containers/booking/booking-form.js